import { render, staticRenderFns } from "./riskVariableUsed.vue?vue&type=template&id=2dda21a2&scoped=true"
import script from "./riskVariableUsed.vue?vue&type=script&lang=js"
export * from "./riskVariableUsed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dda21a2",
  null
  
)

export default component.exports